import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import React from 'react';

import { Icon } from 'packages/common-frontend/components/icons';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

export const SavingStatusTag = () => {
  const savingState = useCreditAgreementStore((store) => {
    if (store.isSaving) return 'saving';
    if (store.isCreditAgreementDirty) return 'dirty';
    return 'saved';
  });

  switch (savingState) {
    case 'dirty':
      return (
        <Tag variant="solid-muted" colorScheme="orange">
          <TagLeftIcon>
            <Icon icon="pencil" size="md" />
          </TagLeftIcon>
          <TagLabel>Draft: Unsaved</TagLabel>
        </Tag>
      );
    case 'saving':
      return (
        <Tag variant="solid-muted" colorScheme="orange">
          <TagLeftIcon>
            <Icon
              icon="spinner-scale"
              size="md"
              style={{
                animation: '2s linear infinite spin',
                transformOrigin: 'center',
              }}
            />
          </TagLeftIcon>
          <TagLabel>Draft: Saving...</TagLabel>
        </Tag>
      );
    case 'saved':
      return (
        <Tag variant="solid-muted" colorScheme="blue">
          <TagLeftIcon>
            <Icon icon="circle-check" size="md" />
          </TagLeftIcon>
          <TagLabel>Draft: Saved</TagLabel>
        </Tag>
      );
    default:
      return null;
  }
};
